import { render } from "./icon-close.vue?vue&type=template&id=24a64c14"
const script = {}

import exportComponent from "/Users/bradwalker/Sites/clark-atlanta-university/web/modules/custom/idfive_calendar_client/calendar_vue_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__